module.exports = __webpack_public_path__ + "static/img/page1-icon2.7da9d9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page1-icon2.png
// module id = jYav
// module chunks = 216